import { setStakeholders } from "./stakeholderSlice";
import * as stakeholderService from "../../../services/Stakeholder";

export const fetchStakeholdersByPin = (pin, voen) => async dispatch => {
    try {
        const resp = await stakeholderService.getAllStakeholdersByPin(pin, voen);
        dispatch(setStakeholders(resp.data));
    } catch (err) {
        throw err;
    }
}